<template>
    <div class="platform-identify">
        <div style="height: 12px" />


            <el-form class="platform-identify-form" label-width="110px">
                <el-form-item label="平台鉴别">
                    <el-radio v-model="ptjbVle" :label="0">需要鉴别</el-radio>
                    <el-radio v-model="ptjbVle" :label="1" style="margin-left: 16px">不符退回</el-radio>
                    <div class="platform-identify-hint">
                        需要鉴别：查看图谱并给出真/假结果；不符退回：直接判定不通过并走退回/退款逻辑
                    </div>
                </el-form-item>

                <template v-if="ptjbVle === 0">
                    <el-row :gutter="16" v-if="inspectIdentifyProfile(dataInfo).showLiquidBlock">
                        <el-col :span="8">
                            <el-form-item label="标准乙醇">
                                <el-input v-model="identifyBzyc" placeholder="标准乙醇" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="乙醇含量">
                                <el-input v-model="identifyYchl" placeholder="乙醇含量"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <template v-if="inspectIdentifyProfile(dataInfo).showLiquidBlock">
                        <el-form-item label="标准图谱">
                            <div class="platform-identify-actions">
                                <uploadFile @getImg="onStdChartNoCoordUploaded" :isSlot="true">
                                    <el-button type="success" size="small">更改无坐标图谱</el-button>
                                </uploadFile>
                                <uploadFile @getImg="onStdChartCoordUploaded" :isSlot="true">
                                    <el-button type="success" size="small">更改有坐标图谱</el-button>
                                </uploadFile>
                            </div>
                            <div class="platform-identify-std-preview">
                                <div class="platform-identify-std-preview__item">
                                    <div class="platform-identify-std-preview__label">无坐标图谱</div>
                                    <div class="platform-identify-std-preview__thumb">
                                        <el-image v-if="stdChartNoCoord" class="platform-identify-std-preview__img"
                                            :src="stdChartNoCoord" fit="contain"
                                            :preview-src-list="[stdChartNoCoord]" />
                                        <div v-else class="platform-identify-std-preview__empty">暂无图片</div>
                                    </div>
                                </div>
                                <div class="platform-identify-std-preview__item">
                                    <div class="platform-identify-std-preview__label">有坐标图谱</div>
                                    <div class="platform-identify-std-preview__thumb">
                                        <el-image v-if="stdChartCoord" class="platform-identify-std-preview__img"
                                            :src="stdChartCoord" fit="contain" :preview-src-list="[stdChartCoord]" />
                                        <div v-else class="platform-identify-std-preview__empty">暂无图片</div>
                                    </div>
                                </div>
                            </div>
                            <div class="platform-identify-hint">
                                当前：无坐标 {{ stdChartNoCoord ? "已上传" : "未上传" }}；有坐标 {{ stdChartCoord ? "已上传" : "未上传" }}
                            </div>
                        </el-form-item>

                        <el-form-item label="鉴别图谱">
                            <div class="platform-identify-chart-mode">
                                <el-radio-group v-model="identifyChartUploadMode" size="small">
                                    <el-radio-button label="image">上传图片</el-radio-button>
                                    <el-radio-button label="txt">TXT 生成谱图</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div class="platform-identify-jbtp-actions">
                                <template v-if="identifyChartUploadMode === 'image'">
                                    <el-upload class="platform-identify-jbtp-upload" name="file" :show-file-list="false"
                                        :action="uploadUrl" :on-success="onIdentifyChartUploaded">
                                        <el-button type="success" size="small">{{ identifyList.jbtp ? "更换图片" : "上传图片" }}</el-button>
                                    </el-upload>
                                </template>
                                <template v-else>
                                    <el-button type="primary" size="small" plain :loading="identifyTxtGenerating"
                                        @click="triggerIdentifySpectrumTxtPick">选择 TXT 并生成谱图</el-button>
                                    <input ref="identifySpectrumTxtInput" type="file" accept=".txt,text/plain"
                                        class="platform-identify-txt-input" @change="onIdentifySpectrumTxtSelected" />
                                </template>
                            </div>
                            <div class="platform-identify-std-preview platform-identify-jbtp-preview-row">
                                <div class="platform-identify-std-preview__item">
                                    <div class="platform-identify-std-preview__thumb">
                                        <el-image v-if="identifyList.jbtp" class="platform-identify-std-preview__img"
                                            :src="identifyList.jbtp" fit="contain"
                                            :preview-src-list="[identifyList.jbtp]" />
                                        <div v-else class="platform-identify-std-preview__empty">暂无图片</div>
                                    </div>
                                </div>
                            </div>
                        </el-form-item>
                    </template>

                    <el-divider content-position="left">样品信息</el-divider>

                    <el-form-item label="类型">
                        <el-radio-group v-model.number="identifySffz">
                            <el-radio :label="0">分装</el-radio>
                            <el-radio :label="1">不分装</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="批次">
                        <el-radio-group v-model.number="identifyType2">
                            <el-radio :label="0">有批次号</el-radio>
                            <el-radio :label="1">无批次号</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item v-if="identifyType2 === 0" label="批次号">
                        <el-input v-model="identifyBatchNum" placeholder="请输入批次号" maxlength="120"
                            style="max-width: 360px"></el-input>
                    </el-form-item>

                    <el-form-item v-if="identifyRealImgArray.length > 0" label="实物图片"
                        class="platform-identify-real-form-item">
                        <div class="image-grid">
                            <el-image v-for="(item, index) in identifyRealImgArray" :key="index" :src="item"
                                :preview-src-list="identifyRealImgArray"
                                style="width: 80px; height: 80px; margin-right: 5px"></el-image>
                        </div>
                    </el-form-item>

                    <el-divider content-position="left">鉴别结果</el-divider>

                    <el-form-item v-if="appearanceResultLocked" label="外观鉴别结果">
                        <span>{{ appearanceResultLabel }}</span>
                        <span class="platform-identify-hint" style="margin-left: 8px">（小程序已出具）</span>
                    </el-form-item>
                    <el-form-item v-else label="外观鉴别结果">
                        <el-radio v-model="jbjgAppearanceVle" :label="1">通过</el-radio>
                        <el-radio v-model="jbjgAppearanceVle" :label="2" style="margin-left: 16px">不通过</el-radio>
                    </el-form-item>
                    <el-form-item v-if="inspectIdentifyProfile(dataInfo).showLiquidBlock" label="液体鉴别结果">
                        <el-radio v-model="jbjgLiquidVle" :label="1">通过</el-radio>
                        <el-radio v-model="jbjgLiquidVle" :label="2" style="margin-left: 16px">不通过</el-radio>
                    </el-form-item>
                </template>

                <template v-else>
                    <el-alert title="已选择不符退回，确认后提交将判定为不符退回/无法鉴别。" type="warning" :closable="false"
                        show-icon style="margin-bottom: 12px" />
                </template>
            </el-form>

        <span slot="footer" class="dialog-footer" style="display: block; text-align: right; margin-top: 16px;">
            <el-button type="success" :loading="submitLoading" @click="submitInspection">提交出具</el-button>
            <el-button @click="handleCancel">关闭</el-button>
        </span>
    </div>
</template>

<script>
import uploadFile from "@/components/elUpload";
import { api } from "@/util/requestUrl";
import {
    SPECTRUM_TXT_MAX_POINTS,
    parseSpectrumTxt,
    downsampleSpectrumPairs,
    renderTxtSpectrumChartToDataUrlAsync,
} from "@/util/spectrumTxtChart";

export default {
    components: {
        uploadFile,
    },
    props: {
        jobId: {
            type: [Number, String],
            default: null,
        },
        /** 列表行带入：小程序已出具的外观结论（1通过/2不通过） */
        initialResultAppearance: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            dataInfo: {},
            submitLoading: false,

            ptjbVle: 0,

            jbjgAppearanceVle: 1,
            jbjgLiquidVle: 1,

            stdChartNoCoord: "",
            stdChartCoord: "",
            identifyList: {
                jbtp: "",
            },
            identifyChartUploadMode: "image",
            identifyTxtGenerating: false,
            identifySffz: 1,
            identifyType2: 0,
            identifyBatchNum: "",
            identifyYchl: "",
            identifyBzyc: "",

            identifyRealImg: {
                img1: "",
                img2: "",
                img3: "",
                img4: "",
            },

            uploadUrl: api.uploadImg,
        };
    },
    computed: {
        identifyRealImgArray() {
            let img = [];
            const realpicture = this.dataInfo.realpicture;
            if (realpicture) {
                try {
                    const parsedImg = typeof realpicture === "object" ? realpicture : JSON.parse(realpicture);
                    if (parsedImg) {
                        if (Array.isArray(parsedImg)) {
                            img = parsedImg;
                        } else if (typeof parsedImg === "object") {
                            img = Object.values(parsedImg).filter((v) => v);
                        }
                    }
                } catch (e) { }
            }
            return img;
        },
        previewCombinedInspectionShort() {
            const appPass = this.jbjgAppearanceVle === 1;
            const liqPass = this.jbjgLiquidVle === 1;
            const showLiquid = this.inspectIdentifyProfile(this.dataInfo).showLiquidBlock;
            if (showLiquid) {
                return appPass && liqPass ? "通过" : "不通过";
            }
            return appPass ? "通过" : "不通过";
        },
        previewIdentifyBatchLine() {
            if (Number(this.identifyType2) === 1) return "无批次号";
            return this.identifyBatchNum || "-";
        },
        resolvedAppearanceResult() {
            const d = this.dataInfo || {};
            let ra = this.parseAppearanceResult(d.resultAppearance);
            if (ra != null) return ra;
            return this.parseAppearanceResult(this.initialResultAppearance);
        },
        appearanceResultLocked() {
            const r = this.resolvedAppearanceResult;
            return r === 1 || r === 2;
        },
        appearanceResultLabel() {
            const r = this.resolvedAppearanceResult;
            if (r === 1) return "通过";
            if (r === 2) return "不通过";
            return "-";
        },
    },
    watch: {
        jobId: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.loadData();
                }
            },
        },
        resolvedAppearanceResult: {
            immediate: true,
            handler(val) {
                if (val === 1 || val === 2) {
                    this.jbjgAppearanceVle = val;
                }
            },
        },
    },
    methods: {
        parseAppearanceResult(val) {
            if (val == null || val === "") return null;
            const n = Number(val);
            return n === 1 || n === 2 ? n : null;
        },

        loadData() {
            this.$https(api.getInspectionJobById, { id: this.jobId }, "GET").then((res) => {
                if (res.data && res.data.code === 200) {
                    this.dataInfo = res.data.data || {};
                    this.openPlatformIdentify();
                } else {
                    this.$message.error(res.data.msg || "加载失败");
                }
            });
        },

        safeJsonParse(str) {
            if (!str) return null;
            try {
                return JSON.parse(String(str));
            } catch (e) {
                return null;
            }
        },

        normalizeChartUrl(url) {
            if (!url) return "";
            const s = String(url).trim();
            if (!s) return "";
            if (/^https?:\/\//i.test(s)) return s;
            const base = "https://hzshixiang.site";
            return s.startsWith("/") ? base + s : base + "/" + s;
        },

        /** 标准图谱：作业已存 > 报告 JSON > 关联型号 Type */
        openPlatformIdentify() {
            const d = this.dataInfo;
            if (!d || !d.id) return;
            const typeId = d.typeId || (d.type && d.type.id);
            if (typeId) {
                this.$https(api.selType, { id: typeId, page: 1, size: 1 }, "POST")
                    .then((res) => {
                        let a1 = "";
                        let a2 = "";
                        let typeBzyc = "";
                        if (res.data && Number(res.data.code) === 200 && Array.isArray(res.data.data) && res.data.data.length) {
                            const row = res.data.data[0];
                            a1 = row.atlas1 != null ? String(row.atlas1).trim() : "";
                            a2 = row.atlas2 != null ? String(row.atlas2).trim() : "";
                            typeBzyc = row.bzyc != null ? String(row.bzyc).trim() : "";
                        }
                        this.applyPlatformIdentifyFormState(d, a1, a2, typeBzyc);
                    })
                    .catch(() => {
                        this.applyPlatformIdentifyFormState(d, "", "", "");
                    });
            } else {
                this.applyPlatformIdentifyFormState(d, "", "", "");
            }
        },

        applyPlatformIdentifyFormState(d, typeAtlas1, typeAtlas2, typeBzyc) {
            if (!d || !d.id) return;

            let stdNo = (d.atlas1 && String(d.atlas1).trim()) || "";
            let stdCoord = (d.atlas2 && String(d.atlas2).trim()) || "";
            const typeObj = d.type;
            if (!stdNo && typeObj && typeObj.atlas1) stdNo = String(typeObj.atlas1).trim();
            if (!stdCoord && typeObj && typeObj.atlas2) stdCoord = String(typeObj.atlas2).trim();

            const payload = this.safeJsonParse(d.inspectionReportJson);
            if (payload && payload.schema === "platform_identify_v1") {
                const ch = payload.charts || {};
                if (!stdNo && ch.stdNoCoord) stdNo = String(ch.stdNoCoord).trim();
                if (!stdCoord && ch.stdCoord) stdCoord = String(ch.stdCoord).trim();
            }
            if (!stdNo && typeAtlas1) stdNo = String(typeAtlas1).trim();
            if (!stdCoord && typeAtlas2) stdCoord = String(typeAtlas2).trim();

            this.stdChartNoCoord = this.normalizeChartUrl(stdNo);
            this.stdChartCoord = this.normalizeChartUrl(stdCoord);

            let jbtp = (d.jbtpUrl && String(d.jbtpUrl).trim()) || "";
            if (payload && payload.schema === "platform_identify_v1") {
                const ch = payload.charts || {};
                if (!jbtp && ch.identify) jbtp = String(ch.identify).trim();
            }
            this.identifyList = { jbtp: this.normalizeChartUrl(jbtp) };

            this.identifySffz = d.sffz != null ? Number(d.sffz) : 1;
            this.identifyType2 = d.type2 != null ? Number(d.type2) : 0;
            this.identifyBatchNum = d.batchNum || "";

            let ychl = (d.ychl && String(d.ychl).trim()) || "";
            let bzyc = (d.bzyc && String(d.bzyc).trim()) || "";
            if (payload && payload.schema === "platform_identify_v1" && payload.meta) {
                if (!ychl && payload.meta.ychl) ychl = String(payload.meta.ychl).trim();
                if (!bzyc && payload.meta.bzyc) bzyc = String(payload.meta.bzyc).trim();
            }
            if (!bzyc && typeBzyc) bzyc = String(typeBzyc).trim();
            if (!bzyc && typeObj && typeObj.bzyc) bzyc = String(typeObj.bzyc).trim();
            this.identifyYchl = ychl;
            this.identifyBzyc = bzyc;

            const appRa = this.parseAppearanceResult(d.resultAppearance)
                || this.parseAppearanceResult(this.initialResultAppearance);
            if (appRa != null) {
                this.jbjgAppearanceVle = appRa;
            }
            if (d.resultLiquid != null) {
                this.jbjgLiquidVle = d.resultLiquid;
            }

            this.identifyChartUploadMode = "image";
            this.identifyTxtGenerating = false;
        },

        inspectIdentifyProfile(detail) {
            const inspectionType = detail && detail.inspectionType;
            const showLiquidBlock = inspectionType === 1 || inspectionType === 2;
            return { showLiquidBlock };
        },

        inspectionTypeLabel(type) {
            const t = Number(type);
            if (t === 3) return "外观";
            if (t === 1 || t === 2) return "外观+液体鉴别";
            return "-";
        },

        inspectionTypeHint(detail) {
            const t = detail && detail.inspectionType;
            if (t === 1 || t === 2) return "需完成外观鉴别与液体鉴别";
            if (t === 3) return "仅需完成外观鉴别";
            return "";
        },

        getOrderTypeLabel(type) {
            const labels = {
                1: "寄售订单",
                2: "鉴别订单",
                3: "二手订单",
                4: "安心购订单",
            };
            return labels[type] || "-";
        },

        secondhandSffzLabel(sffz) {
            return sffz === 0 ? "分装" : "不分装";
        },

        onStdChartNoCoordUploaded(path) {
            this.stdChartNoCoord = this.normalizeChartUrl(path);
        },

        onStdChartCoordUploaded(path) {
            this.stdChartCoord = this.normalizeChartUrl(path);
        },

        onIdentifyChartUploaded(res) {
            const p =
                (res && res.data && res.data.path) ||
                (res && res.data && res.data.data && res.data.data.path) ||
                (res && res.path) ||
                "";
            if (p) {
                this.$set(this.identifyList, "jbtp", this.normalizeChartUrl(p));
                this.$message.success("上传成功");
            } else {
                this.$message.error("上传失败");
            }
        },

        triggerIdentifySpectrumTxtPick() {
            const el = this.$refs.identifySpectrumTxtInput;
            if (el) el.click();
        },

        onIdentifySpectrumTxtSelected(ev) {
            const input = ev && ev.target;
            if (!input || !input.files || !input.files[0]) return;
            const file = input.files[0];
            input.value = "";
            const name = (file.name || "").toLowerCase();
            if (!name.endsWith(".txt")) {
                this.$message.warning("请选择 .txt 文本文件");
                return;
            }
            this.identifyTxtGenerating = true;
            const reader = new FileReader();
            reader.onload = () => {
                try {
                    const text = String(reader.result || "");
                    const rawPts = parseSpectrumTxt(text);
                    if (rawPts.length < 2) {
                        this.identifyTxtGenerating = false;
                        this.$message.error("未能从 TXT 中解析出有效数据点，请检查是否为两列数值格式");
                        return;
                    }
                    const pts = downsampleSpectrumPairs(rawPts, SPECTRUM_TXT_MAX_POINTS);
                    renderTxtSpectrumChartToDataUrlAsync(pts)
                        .then((dataUrl) => this.uploadIdentifyChartFromDataUrl(dataUrl))
                        .then(() => {
                            this.$message.success("谱图已生成并上传");
                        })
                        .catch((e) => {
                            this.$message.error((e && e.message) || "谱图生成或上传失败");
                        })
                        .finally(() => {
                            this.identifyTxtGenerating = false;
                        });
                } catch (err) {
                    this.identifyTxtGenerating = false;
                    this.$message.error((err && err.message) || "生成谱图失败");
                }
            };
            reader.onerror = () => {
                this.identifyTxtGenerating = false;
                this.$message.error("读取文件失败");
            };
            reader.readAsText(file, "UTF-8");
        },

        dataURLtoFile(base64Str, fileName) {
            const arr = base64Str.split(",");
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], fileName, { type: mime });
        },

        uploadIdentifyChartFromDataUrl(dataUrl) {
            return new Promise((resolve, reject) => {
                const no = new Date().valueOf() + "_" + Math.round(Math.random() * 1000);
                let imgFile;
                try {
                    imgFile = this.dataURLtoFile(dataUrl, no + ".png");
                } catch (e) {
                    reject(new Error("图片数据转换失败"));
                    return;
                }
                const form = new FormData();
                form.append("file", imgFile);
                form.append("no", no);
                this.$https(api.uploadImg, form, "POST")
                    .then((res) => {
                        const inner = res && res.data;
                        const payload = inner && inner.data;
                        const p = (payload && payload.path) || (inner && inner.path) || "";
                        if (p) {
                            this.$set(this.identifyList, "jbtp", this.normalizeChartUrl(p));
                            resolve(p);
                        } else {
                            reject(new Error((inner && inner.msg) || "上传失败"));
                        }
                    })
                    .catch(() => {
                        reject(new Error("网络错误"));
                    });
            });
        },

        handleCancel() {
            this.$emit("close");
        },

        submitInspection() {
            const showLiquid = this.inspectIdentifyProfile(this.dataInfo).showLiquidBlock;
            if (this.ptjbVle === 0 && showLiquid) {
                if (this.jbjgAppearanceVle === 1 && this.jbjgLiquidVle === 1) {
                    if (!this.identifyList.jbtp) {
                        this.$message.warning("请先上传图谱数据");
                        return;
                    }
                }
            }

            const tokenStr = sessionStorage.getItem('TOKEN') || '';
            const tokenParts = tokenStr.split('_');
            const managerId = tokenParts.length > 1 ? parseInt(tokenParts[1]) : null;
            const managerName = this.$store.state.USER.account || '';

            let resultAppearance;
            let resultLiquid;
            if (this.ptjbVle === 1) {
                resultAppearance = 2;
                resultLiquid = 2;
            } else {
                resultAppearance = this.appearanceResultLocked
                    ? this.resolvedAppearanceResult
                    : this.jbjgAppearanceVle;
                resultLiquid = this.jbjgLiquidVle;
            }

            const submitData = {
                id: this.jobId,
                ptjb: this.ptjbVle,
                resultAppearance: resultAppearance,
                managerId: managerId,
                inspectorName: managerName,
            };
            if (showLiquid) {
                submitData.resultLiquid = resultLiquid;
                submitData.ychl = this.identifyYchl || "";
                submitData.bzyc = this.identifyBzyc || "";
                submitData.jbtp = this.identifyList.jbtp || "";
                submitData.atlas1 = this.stdChartNoCoord || "";
                submitData.atlas2 = this.stdChartCoord || "";
            }

            this.submitLoading = true;
            this.$axios
                .post(api.submitInspectionJobResult, submitData)
                .then((res) => {
                    if (res.data && res.data.code === 200) {
                        this.$message.success("提交成功");
                        this.$emit("success");
                    } else {
                        this.$message.error(res.data.msg || "提交失败");
                    }
                })
                .catch(() => {
                    this.$message.error("网络异常");
                })
                .finally(() => {
                    this.submitLoading = false;
                });
        },
    },
};
</script>

<style scoped>
.platform-identify {
    padding: 0 8px;
}

.platform-identify-form {
    margin-top: 8px;
}

.platform-identify-hint {
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
    margin-top: 4px;
}

.platform-identify-service-sub {
    font-size: 12px;
    color: #909399;
    margin-top: 2px;
}

.platform-identify-actions {
    display: flex;
    gap: 8px;
    margin-bottom: 10px;
    text-align: center;
}

.platform-identify-std-preview {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 8px;
}

.platform-identify-std-preview__item {
    flex: 1;
}

.platform-identify-std-preview__label {
    font-size: 12px;
    color: #606266;
    margin-bottom: 4px;
    text-align: center;
}

.platform-identify-std-preview__thumb {
    max-width: 95%;
    height: 180px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.platform-identify-std-preview__img {
    width: 100%;
    height: 100%;
}

.platform-identify-std-preview__empty {
    color: #c0c4cc;
    font-size: 12px;
}

.platform-identify-chart-mode {
    margin-bottom: 8px;
}

.platform-identify-jbtp-actions {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 8px;
}

.platform-identify-jbtp-upload {
    display: inline-block;
}

.platform-identify-txt-input {
    display: none;
}

.platform-identify-jbtp-preview-row {
    margin-top: 8px;
}

.platform-identify-real-form-item {
    margin-bottom: 0;
}

.platform-identify-real-strip {
    display: flex;
    gap: 12px;
}

.platform-identify-real-slot {
    text-align: center;
}

.platform-identify-real-slot__cap {
    font-size: 12px;
    color: #606266;
    margin-bottom: 4px;
}

.platform-identify-real-slot__box {
    width: 80px;
    height: 80px;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f7fa;
}

.platform-identify-real-slot__upload {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.platform-identify-real-slot__empty {
    color: #c0c4cc;
    font-size: 12px;
}

.issue-desc-radio-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.issue-desc-radio {
    margin-left: 0 !important;
}

.issue-desc-custom-input {
    margin-top: 8px;
    max-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/pages/inspectionJob/orderVerify.vue